import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import "./MobileCoinAllotFilterPopup.css";
import axios from "axios";
import { Api } from "../../../../BackendApi/api";
import { formatIndianDate } from "../../../../Component/IndFormatDate/formatIndianDate";

const MobileCoinAllotFilterPopup = ({
  onClose,
  columnSearch,
  setColumnSearch,
}) => {
  const [startDate, setStartDate] = useState(columnSearch.startDate || null);
  const [endDate, setEndDate] = useState(columnSearch.endDate || null);
  const [status, setStatus] = useState(columnSearch.status || "active");
  const [activeCoins, setActiveCoins] = useState(0);
  const [deactiveCoins, setDeactiveCoins] = useState(0);

  const fetchTotalCoins = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const payload = {
        startfrom: 0,
        limit: 1000,
        transDateStartDate: startDate ? formatIndianDate(new Date(startDate)) : "",
        transDateEndDate: endDate ? formatIndianDate(new Date(endDate)) : "",
      };

      const res = await axios.post(Api.getCoinAllot, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === 1 && Array.isArray(res.data.data)) {
        const coins = res.data.data;

      
        const activeTotal = coins
          .filter((i) => i.Status === "ACTIVE" && i.TransType === "IN")
          .reduce((sum, i) => sum + Number(i.TransValue || 0), 0);

      
        const deactiveTotal = coins
          .filter((i) => i.Status === "Deactive" && i.TransType === "OUT")
          .reduce((sum, i) => sum + Number(i.TransValue || 0), 0);

        setActiveCoins(activeTotal);
        setDeactiveCoins(deactiveTotal);
      }
    } catch (err) {
      console.error("Error fetching total coins:", err);
    }
  };

  useEffect(() => {
    fetchTotalCoins();
  }, [status, startDate, endDate]);

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);

    
    setColumnSearch({
      ...columnSearch,
      status: value === "" ? "" : value,
    });
  };

  return (
    <div className="product-filter-popup-overlay" onClick={onClose}>
      <div className="product-filter-popup" onClick={(e) => e.stopPropagation()}>
        <h3>Filters</h3>

    
        <div className="total-coin-display">
          <div className="coin-total-item active">
            <span>Alloted Coins:</span> <strong>{activeCoins}</strong>
          </div>
          <div className="coin-total-item deactive">
            <span>Deducted Coins:</span> <strong>{deactiveCoins}</strong>
          </div>
        </div>

        <div className="mobile-product-filter-group">
          <label>Status</label>
          <select value={status} onChange={handleStatusChange}>
            <option value="active">Active</option>
            <option value="deactive">DeActive</option>
            <option value="">All</option>
          </select>
        </div>

    
        <div className="product-date-row" style={{ marginTop: "10px" }}>
          <div className="mobile-product-filter-group">
            <label>Start Date</label>
            <div className="product-date-wrapper">
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setColumnSearch({ ...columnSearch, startDate: date });
                }}
                placeholderText="Start Date"
                dateFormat="dd/MM/yyyy"
                className="product-mobile-date-picker"
              />
              <FaCalendarAlt className="calendar-icon" />
            </div>
          </div>

          <div className="mobile-product-filter-group">
            <label>End Date</label>
            <div className="product-date-wrapper">
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  setColumnSearch({ ...columnSearch, endDate: date });
                }}
                placeholderText="End Date"
                dateFormat="dd/MM/yyyy"
                className="product-mobile-date-picker"
              />
              <FaCalendarAlt className="calendar-icon" />
            </div>
          </div>
        </div>

        <button className="product-filter-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default MobileCoinAllotFilterPopup;
